module.exports = __webpack_public_path__ + "img/contact_address_bj.5a29a4c8.png";